// extracted by mini-css-extract-plugin
export default {"detailsContainer":"contact-details_detailsContainer__llCTg","detailItem":"contact-details_detailItem__9jqgM","flexRow":"contact-details_flexRow__xhx40"};